import React from "react";

import LoginForm from "../components/LoginForm";
const Login = props => {
  return (
    <div className="login-container">
      <LoginForm />
    </div>
  );
};

export default Login;
